<template>
    <LayoutProfile>
        <template v-slot:title>{{ $t('menu.privacy_settings') }}</template>

        <article class="section-item">
            <header class="section-item__row">
                <div class="section-item__heading">
                    <span class="section-item__heading__title">{{ $t('menu.privacy_settings') }}</span>
                </div>
            </header>

            <div class="p-3" v-if="$store.state.appConfig.appConfigReady">
                <div>{{ $t('pages.profile_privacy.third_party_title') }}
                    <div class="d-block" v-if="$store.state.appConfig.marketingConsentDescription">
                        <span v-html="$store.state.appConfig.marketingConsentDescription"></span>
                    </div>
                    <div class="d-block" v-else>
                        {{ $t('pages.profile_privacy.third_party_content') }}
                        <div class="mt-2 small">{{ $t('pages.profile_privacy.date_third_party_document_last_update')
                            }}
                        </div>
                    </div>
                </div>
                <b-form-group class="text-right radio-privacy-settings">
                    <b-form-radio-group
                            id="btn-radios-2"
                            v-model="consent3rdPartyMarketing"
                            :options="options"
                            buttons
                            button-variant="outline-primary"
                            size="sm"
                            name="radio-inline"
                            class="mt-4"
                    ></b-form-radio-group>
                </b-form-group>
            </div>

            <footer class="section-item__footer">
                <div class="total-wrapper">
                    <div class="items w-50">
                      <span v-if="!$store.state.appConfig.hideMarketingConsentLastupdateDate">
                        {{ $t('pages.profile_privacy.date_last_update') }} {{ this.consentMarketingUpdatedAt|formatDateTime }}
                      </span>
                    </div>
                    <b-button variant="primary" @click="save()">
                        {{ $t('pages.profile_privacy.action_save') }}
                    </b-button>
                </div>
            </footer>
        </article>
    </LayoutProfile>
</template>


<script>
    import UserService from "@/services/User.js"
    import LayoutProfile from "@/components/LayoutProfile"

    export default {
        components: {
            LayoutProfile
        },

        data() {
            return {
                consent3rdPartyMarketing: null,
                options: [
                    { text: this.$t('pages.profile_privacy.value_true'), value: true },
                    { text: this.$t('pages.profile_privacy.value_false'), value: false },
                ],
                consentMarketingUpdatedAt: ''
            }
        },

        created() {
            this.fetchData()
        },

        methods: {
            fetchData() {
                UserService.getUserData()
                    .then(response => {
                        console.warn("getUserData", response)
                        // context.commit('SET_PRODUCTS', response.data)
                        this.consentMarketingUpdatedAt = response.data.consent_3rd_party_marketing_updated_at
                        this.consent3rdPartyMarketing = response.data.consent_3rd_party_marketing
                    })
                    .catch(function (error) {
                        // console.log(error)
                        return error
                    })
            },

            save() {
                UserService.updateUser({'consent_3rd_party_marketing': this.consent3rdPartyMarketing})
                    .then(() => {
                        this.$bvToast.toast(this.$t('notifications.changes_saved'))
                        this.fetchData()
                    })
            }
        }
    }
</script>
